import React from "react";
import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import AdditionalInfo from "../../../Components/InfoBox/AdditionalInfo";

/** כמו OrganizedTourStageZeroForm / PackageDetails (מערכת הסוּכן) */
const ORG_TOUR_PUBLIC_DISCLOSURE_ITEMS = [
  "דמי הטיפול / תוספת העמלה של הסוכן אינם כלולים במחיר החדר.",
  "שינוי או ביטול הזמנה כרוכים בדמי טיפול של החברה בסך 85$ לנוסע, בנוסף לדמי הביטול של הספק.",
  "המחיר והזמינות סופיים רק לאחר אישור הספק ושובר.",
  "תנאי הביטול והשינוי נקבעים בלעדית על ידי הספק ועלולים לכלול חיובים מלאים.",
  "ייתכנו אי־דיוקים במידע ובתמונות.",
  "הסוכן מחויב להעביר ללקוח את כל תנאי ההזמנה בצורה מלאה וברורה.",
];

function hasMeaningfulAdditionalHtml(html) {
  const raw = html == null ? "" : String(html);
  return raw.replace(/<[^>]*>/g, "").trim().length > 0;
}

/**
 * מידע נוסף (מ־snapshot) + גילוי נאות וביטולים — כמו במסלול ההזמנה לסוכן.
 */
export default function OrganizedTourPublicOfferNotesLegal({ additionalInfoHtml = "" }) {
  const showAdditional = hasMeaningfulAdditionalHtml(additionalInfoHtml);

  return (
    <div className="organized-tour-public-offer__notes-legal" dir="rtl">
      {showAdditional ? (
        <section
          className="organized-tour-public-offer__notes-legal-section organized-tour-public-offer__notes-legal-section--additional"
          aria-labelledby="org-tour-pub-notes-additional-title"
        >
          <div className="organized-tour-public-offer__notes-legal-section-head">
            <span className="organized-tour-public-offer__notes-legal-icon" aria-hidden>
              <Info size={20} strokeWidth={2.4} />
            </span>
            <div className="organized-tour-public-offer__notes-legal-head-text">
              <h3 id="org-tour-pub-notes-additional-title" className="organized-tour-public-offer__notes-legal-h3">
                מידע נוסף
              </h3>
              <p className="organized-tour-public-offer__notes-legal-sub">מידע נוסף וחשוב על הטיול וההצעה</p>
            </div>
          </div>
          <div className="organized-tour-public-offer__notes-legal-additional-body">
            <AdditionalInfo innerHtml={String(additionalInfoHtml)} />
          </div>
        </section>
      ) : null}

      <section
        className="organized-tour-public-offer__notes-legal-section organized-tour-public-offer__notes-legal-section--disclosure"
        aria-labelledby="org-tour-pub-notes-disclosure-title"
      >
        <h3 id="org-tour-pub-notes-disclosure-title" className="organized-tour-public-offer__notes-legal-disclosure-title">
          גילוי נאות וביטולים
        </h3>
        {ORG_TOUR_PUBLIC_DISCLOSURE_ITEMS.map((text) => (
          <p key={text} className="organized-tour-public-offer__notes-legal-disclosure-item">
            <span className="organized-tour-public-offer__notes-legal-disclosure-bullet" aria-hidden>
              •
            </span>
            {text}
          </p>
        ))}
      </section>

      <p className="organized-tour-public-offer__notes-legal-terms-p">
        <Link to="/termsAndConditions" className="organized-tour-public-offer__notes-legal-terms-link">
          תקנון מלא
        </Link>
      </p>
    </div>
  );
}
